// src/components/Layout/HamburgerMenu.jsx

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    FiUser,
    FiSettings,
    FiBell,
    FiHelpCircle,
    FiLogOut,
    FiMenu,
    FiX
} from 'react-icons/fi';
import {
    MdDashboard,
    MdLocalShipping
} from 'react-icons/md';

const HamburgerMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setIsOpen(false);
    }, [location.pathname]);

    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu = () => setIsOpen(false);



    const handleNavigation = (path) => {
        navigate(path);
        closeMenu();
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login');
        closeMenu();
    };

    const user = JSON.parse(localStorage.getItem('user') || '{}');

    return (
        <>
            {/* هدر ثابت بالای صفحه */}
            <header className="fixed top-0 left-0 right-0 h-16 bg-gradient-to-r from-blue-600 to-blue-700 shadow-lg z-40 flex items-center justify-between px-4">
                {/* لوگو یا عنوان اپلیکیشن (سمت چپ در RTL) */}
                <div className="text-white font-bold text-lg">
                    اپلیکیشن من
                </div>

                {/* دکمه همبرگری (سمت راست) */}
                <button
                    onClick={toggleMenu}
                    className="w-10 h-10 bg-white/20 rounded-lg hover:bg-white/30 transition-all duration-300 flex items-center justify-center focus:outline-none"
                >
                    {isOpen ? (
                        <FiX className="w-5 h-5 text-white" />
                    ) : (
                        <FiMenu className="w-5 h-5 text-white" />
                    )}
                </button>
            </header>

            {/* فاصله برای جلوگیری از تداخل با هدر */}
            <div className="h-16" />

            {/* اوورلی */}
            {isOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40 transition-all duration-300"
                    onClick={closeMenu}
                />
            )}

            {/* منوی کناری (از راست باز می‌شه) */}
            <div dir='rtl'
                className={`fixed top-0 right-0 h-full w-80 bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-out ${
                    isOpen ? 'translate-x-0' : 'translate-x-full'
                }`}
            >
                {/* هدر با اطلاعات کاربر */}
                <div className="bg-gradient-to-r from-blue-600 to-blue-700 p-6 text-white pt-20">
                    <div className="flex items-center gap-4">
                        <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-lg">
                            {user.avatar ? (
                                <img src={user.avatar} alt="avatar" className="w-16 h-16 rounded-full" />
                            ) : (
                                <span className="text-blue-600 font-bold text-2xl">
                                    {user.name?.charAt(0) || 'U'}
                                </span>
                            )}
                        </div>
                        <div>
                            <h3 className="font-bold text-lg">{user.name || 'کاربر مهمان'}</h3>
                            <p className="text-blue-100 text-sm">{user.email || ''}</p>
                            <span className="inline-block mt-1 px-2 py-0.5 bg-white/20 rounded-full text-xs">
                                {user.role === 'admin' ? 'ادمین' : 'کاربر عادی'}
                            </span>
                        </div>
                    </div>
                </div>

                {/* منوها */}
                <div className="p-4 flex flex-col h-[calc(100%-200px)] overflow-y-auto">
                    <nav className="flex-1">
                        <MenuSection title="منوی اصلی">
                            <MenuItem
                                icon={<MdDashboard size={20} />}
                                title="داشبورد"
                                active={location.pathname === '/dashboard'}
                                onClick={() => handleNavigation('/dashboard')}
                            />
                            <MenuItem
                                icon={<MdLocalShipping size={20} />}
                                title="در انتظار تحویل"
                                active={location.pathname === '/pending-delivery'}
                                onClick={() => handleNavigation('/pending-delivery')}
                            />
                            <MenuItem
                                icon={<FiUser size={20} />}
                                title="پروفایل"
                                active={location.pathname === '/profile'}
                                onClick={() => handleNavigation('/profile')}
                            />
                        </MenuSection>


                        <MenuSection title="تنظیمات">
                            <MenuItem
                                icon={<FiSettings size={20} />}
                                title="تنظیمات"
                                active={location.pathname === '/settings'}
                                onClick={() => handleNavigation('/settings')}
                            />
                            <MenuItem
                                icon={<FiBell size={20} />}
                                title="اعلان‌ها"
                                badge="3"
                                active={location.pathname === '/notifications'}
                                onClick={() => handleNavigation('/notifications')}
                            />
                            <MenuItem
                                icon={<FiHelpCircle size={20} />}
                                title="راهنما"
                                active={location.pathname === '/help'}
                                onClick={() => handleNavigation('/help')}
                            />
                        </MenuSection>
                    </nav>

                    {/* دکمه خروج */}
                    <div className="pt-4 border-t border-gray-200">
                        <MenuItem
                            icon={<FiLogOut size={20} />}
                            title="خروج از حساب"
                            onClick={handleLogout}
                            className="text-red-600 hover:bg-red-50"
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

// کامپوننت بخش منو
const MenuSection = ({ title, children }) => (
    <div className="mb-6">
        <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 px-3">
            {title}
        </h4>
        {children}
    </div>
);

// کامپوننت آیتم منو - برای RTL از pr-8 استفاده شد
const MenuItem = ({ icon, title, active, onClick, badge, indent = false, className = '' }) => (
    <button
        onClick={onClick}
        className={`w-full flex items-center justify-between px-3 py-2.5 rounded-lg transition-all duration-200 ${
            active
                ? 'bg-blue-50 text-blue-600'
                : 'text-gray-700 hover:bg-gray-100'
        } ${indent ? 'pr-8' : ''} ${className}`}
    >
        <div className="flex items-center gap-3">
            <span className="text-gray-600">{icon}</span>
            <span className="font-medium text-sm">{title}</span>
        </div>
        {badge && (
            <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                {badge}
            </span>
        )}
    </button>
);

export default HamburgerMenu;